import { ContactInfo } from 'src/app/recruiting/deals/models/contact-info.model';

export interface OfferTeamContactDto {
    role: string;
    name: string | null;
    email: string | null;
    phone: string | null;
}

export type ContactSource = ContactInfo['source'];

export interface RoleDisplayConfig {
    role: string;
    label: string;
    source: ContactSource;
}

export const ROLE_DISPLAY_CONFIG: RoleDisplayConfig[] = [
    { role: 'Recruiter', label: 'Recruiter', source: 'candidate' },
    { role: 'Recruiter Leader', label: 'Recruiter Leader', source: 'candidate' },
    { role: 'Recruiter FAST Lead', label: 'Recruiter FAST Lead', source: 'facility' },
    { role: 'Allied FAST Lead', label: 'Allied FAST Lead', source: 'facility' },
    { role: 'Account Manager', label: 'Account Manager', source: 'facility' },
    { role: 'Account Coordinator', label: 'Account Coordinator', source: 'facility' },
    { role: 'AM Team Manager', label: 'AM Team Manager', source: 'facility' }
];

export const ROLE_DISPLAY_CONFIG_WFD: RoleDisplayConfig[] = [
    { role: 'Recruiter', label: 'Recruiter', source: 'candidate' },
    { role: 'Recruiter Leader', label: 'Recruiter Leader', source: 'candidate' },
    { role: 'WFD Recruiter', label: 'WFD Recruiter', source: 'candidate' },
    { role: 'Recruiter FAST Lead', label: 'Recruiter FAST Lead', source: 'facility' },
    { role: 'Allied FAST Lead', label: 'Allied FAST Lead', source: 'facility' },
    { role: 'Account Manager', label: 'Account Manager', source: 'facility' },
    { role: 'Account Coordinator', label: 'Account Coordinator', source: 'facility' },
    { role: 'AM Team Manager', label: 'AM Team Manager', source: 'facility' }
];

export const CONTACT_QA_IDS: readonly string[] = [
    'recruitername',
    'recruiterleadername',
    'recruiterfastleadname',
    'alliedfastleadname',
    'amcontactname',
    'accontactname',
    'atmcontactname'
];

export const CONTACT_QA_IDS_WFD: readonly string[] = [
    'recruitername',
    'recruiterleadername',
    'wfdrecruitername',
    'recruiterfastleadname',
    'alliedfastleadname',
    'amcontactname',
    'accontactname',
    'atmcontactname'
];
